@if (firstSegment){
<div class="vy-flight-journey-sidepanel">
  <div class="marginBottom-m">
    @if(firstSegmentDs.dateOrigin| date: 'EEEE, dd MMMM':undefined:translateService.currentLang; as subtitle){
    <vy-route-title
      [config]="{origin: {label: firstSegmentDs.placeOrigin }, destination: {label: secondSegmentDs?.placeDestination ?? firstSegmentDs.placeDestination}, subtitle: subtitle}"
    ></vy-route-title>
    }
  </div>
  <div class="vy-flight-journey-sidepanel_time-label marginBottom-m">
    <span class="ds-icon-time"></span>
    <span class="bodyS marginLeft-xs"
      ><strong
        >{{ 'booking_details_component.flight_journey_summary_component.total_trip_time' | translate: {duration:
        data.journeyData.totalTripTime! | formatHours} }}</strong
      ></span
    >
  </div>

  <div class="vy-flight-journey-sidepanel_logo_code">
    <span [class]="getOperatorIcon(firstSegment)">
      <span class="path1"></span>
      <span class="path2"></span>
    </span>
    <span class="bodyXS">
      {{ firstSegment.codeShareCarrierName ?? firstSegment.carrierName }} {{ firstSegment.codeShareFlightNumber ??
      firstSegment.flightNumber }} @if(firstSegment.codeShareOperatorName; as name){
      <span>
        {{ 'booking_details_component.flight_journey_summary_component.operated_by' | translate: {operator: name} }}
      </span>
      }
    </span>
  </div>
  @if (firstSegmentDs) {
  <vy-flight-journey [flightJourneyData]="firstSegmentDs"></vy-flight-journey>
  } @if(data.journeyData.connectionTime){
  <div class="vy-flight-journey-sidepanel_connection_info">
    <div class="vy-flight-journey-sidepanel_connection_info_time">
      <span class="ds-icon-time"></span>
      <span class="bodyS marginLeft-xs"
        >{{ 'booking_details_component.flight_journey_summary_component.connection' | translate: { time:
        data.journeyData.connectionTime | formatHours, station: data.journeyData.connectionStation } }}</span
      >
    </div>

    @if(data.journeyData.isPlusDay){
    <vy-process-message
      [processMessageText]="'booking_details_component.flight_journey_summary_component.plus_one_day_label' | translate : {arrivalDate:
        ((secondSegmentDs != undefined ? secondSegmentDs.dateDestination : firstSegmentDs.dateDestination) | date: 'EEEE, dd MMMM' : undefined :translateService.currentLang)}"
      [size]="ProcessMessageSizeEnum.S"
      [type]="ProcessMessageTypeEnum.INFO"
    ></vy-process-message>
    }
  </div>
  } @if(secondSegment){
  <div class="vy-flight-journey-sidepanel_logo_code">
    <span [class]="getOperatorIcon(secondSegment)">
      <span class="path1"></span>
      <span class="path2"></span>
    </span>
    <span class="bodyXS">
      {{ secondSegment.codeShareCarrierName ?? secondSegment.carrierName }} {{ secondSegment.codeShareFlightNumber ??
      secondSegment.flightNumber }} @if(secondSegment.codeShareOperatorName; as carrierConnectionName){
      <span class="marginLeft-s">
        {{ 'booking_details_component.flight_journey_summary_component.operated_by' | translate: {operator:
        carrierConnectionName} }}
      </span>
      }
    </span>
  </div>
  } @if(secondSegmentDs){
  <vy-flight-journey [flightJourneyData]="secondSegmentDs"></vy-flight-journey>
  }
</div>
}
